import _ from 'lodash';

type PaymentIncentive = {
  discountName?: string | null;
  name?: string | null;
  amount: number | string;
};

type LineItemIncentive = {
  type: string | null | undefined;
  value: number;
};

export const incentivesPerLineItem = (paymentIncentives: PaymentIncentive[]): LineItemIncentive[] =>
  _.map(paymentIncentives, (incentive) => ({
    type: incentive.discountName ?? incentive.name,
    value: Number(incentive.amount) / 100,
  }));

/**
 * IncentivesPerLineItem is an array of objects that represent the incentives rewarded for each line item.
 * The object has the following structure:
 * {
 * type: "Pay By Bank Incentive",
 * value: 1.00
 * },
 * {
 * type: "Pay By Bank Incentive",
 * value: 2.60
 * }
 *
 * Consolidate the incentives by type and sum the values.
 * {
 * type: "Pay By Bank Incentive",
 * value: 3.60
 * }
 */
export const consolidateIncentives = (incentives: LineItemIncentive[]): LineItemIncentive[] =>
  _.map(_.groupBy(incentives, 'type'), (incentivesForType, type) => ({
    type,
    value: _.sumBy(incentivesForType, 'value'),
  }));
